module.exports = __webpack_public_path__ + "static/img/SettingRole.63266a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_icon/SettingRole.png
// module id = w4hd
// module chunks = 58